import React from "react";
import PupilTimePoint from "./PupilTimePoint";

const PupilSection = ({ formData, setFormData }) => {
  const timePoints = [
    { id: "arrest", title: "CPR 중" },
    { id: "ROSC", title: "ROSC 직후" },
    { id: "12hrs", title: "12시간 직후" },
    { id: "24hrs", title: "24시간 직후" },
    { id: "36hrs", title: "36시간 직후" },
    { id: "48hrs", title: "48시간 직후" },
    { id: "60hrs", title: "60시간 직후" },
    { id: "72hrs", title: "72시간 직후" },
  ];

  return (
    <section className="form-section">
      <h3>4-2. Pupil</h3>

      {timePoints.map((point) => (
        <PupilTimePoint
          key={point.id}
          formData={formData}
          setFormData={setFormData}
          timePoint={point.id}
          title={point.title}
        />
      ))}
    </section>
  );
};

export default PupilSection;
